<template>
	<div id="configureReportNewApp-container">
    <div v-if="!showRegVariables.preview">
      <nav id="sideBar-box">
        <div>
          <ul>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showInitInfo'}]" @click="toggleAllNavShows('showInitInfo')">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8337 17.5V15.8333C15.8337 14.9493 15.4825 14.1014 14.8573 13.4763C14.2322 12.8512 13.3844 12.5 12.5003 12.5H7.50033C6.61627 12.5 5.76842 12.8512 5.1433 13.4763C4.51818 14.1014 4.16699 14.9493 4.16699 15.8333V17.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.0003 9.16667C11.8413 9.16667 13.3337 7.67428 13.3337 5.83333C13.3337 3.99238 11.8413 2.5 10.0003 2.5C8.15938 2.5 6.66699 3.99238 6.66699 5.83333C6.66699 7.67428 8.15938 9.16667 10.0003 9.16667Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Initial Information
            </li>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showTestScore'}]" @click="toggleAllNavShows('showTestScore')">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.16699 17.5V12.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 17.5V2.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.833 17.5V7.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Test Score
            </li>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showAttention'}]" @click="toggleAllNavShows('showAttention')">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2406_2687)">
                <path d="M10.0003 18.3334C14.6027 18.3334 18.3337 14.6025 18.3337 10.0001C18.3337 5.39771 14.6027 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001C1.66699 14.6025 5.39795 18.3334 10.0003 18.3334Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.66699 11.6667C6.66699 11.6667 7.91699 13.3334 10.0003 13.3334C12.0837 13.3334 13.3337 11.6667 13.3337 11.6667" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.5 7.5H7.50833" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.5 7.5H12.5083" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_2406_2687">
                <rect width="20" height="20" fill="white"/>
                </clipPath>
                </defs>
              </svg>
              Attention & Emotion
            </li>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showGraphs'}]" @click="toggleAllNavShows('showGraphs')">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.333 5.83325H18.333V10.8333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M18.3337 5.83325L11.2503 12.9166L7.08366 8.74992L1.66699 14.1666" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Graph & Plots
            </li>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showSummary'}]" @click="toggleAllNavShows('showSummary')">
              <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.19401 1.22583H5.51628C5.17775 1.22583 4.90332 1.50026 4.90332 1.83879V3.0647C4.90332 3.40322 5.17775 3.67765 5.51628 3.67765H9.19401C9.53254 3.67765 9.80697 3.40322 9.80697 3.0647V1.83879C9.80697 1.50026 9.53254 1.22583 9.19401 1.22583Z" stroke-width="1.22591" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.80762 2.4519H11.0335C11.3587 2.4519 11.6705 2.58106 11.9004 2.81097C12.1303 3.04087 12.2594 3.35268 12.2594 3.67782V12.2592C12.2594 12.5843 12.1303 12.8961 11.9004 13.126C11.6705 13.3559 11.3587 13.4851 11.0335 13.4851H3.67806C3.35293 13.4851 3.04111 13.3559 2.81121 13.126C2.58131 12.8961 2.45215 12.5843 2.45215 12.2592V3.67782C2.45215 3.35268 2.58131 3.04087 2.81121 2.81097C3.04111 2.58106 3.35293 2.4519 3.67806 2.4519H4.90397" stroke-width="1.22591" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Summary & Recommendations
            </li>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showRootCause'}]" @click="toggleAllNavShows('showRootCause')">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6667 1.66675V6.66675C11.6666 6.94632 11.7368 7.22143 11.8709 7.46675L16.4626 15.8667C16.6014 16.1206 16.6719 16.4062 16.6669 16.6955C16.6619 16.9848 16.5816 17.2679 16.4341 17.5167C16.2865 17.7656 16.0767 17.9718 15.8252 18.115C15.5738 18.2582 15.2894 18.3335 15.0001 18.3334H5.00006C4.71071 18.3335 4.42632 18.2582 4.17489 18.115C3.92345 17.9718 3.71362 17.7656 3.56605 17.5167C3.41848 17.2679 3.33825 16.9848 3.33326 16.6955C3.32826 16.4062 3.39867 16.1206 3.53756 15.8667L8.12923 7.46675C8.2633 7.22143 8.33351 6.94632 8.33339 6.66675V1.66675" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.37793 12.5H14.6229" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.08301 1.66675H12.9163" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Root Cause Analysis
            </li>
            <li :class="[{'navClick': showNavVariables.toggleNavSelect == 'showConfig'}]" @click="toggleAllNavShows('showConfig')">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.33301 4.16675H16.6663" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.33301 10H16.6663" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.33301 15.8333H16.6663" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Configure Menu
            </li>
          </ul>
          <div>
            <button class="primary-button-sm-global" @click="backToAppConfig">Back</button>
          </div>
        </div>
        <div>
          <button @click="showPreview" class="primary-button-sm-global">Preview PDF</button>
        </div>
      </nav>
      <section id="main-box">
        <div v-if="showNavVariables.showInitInfo" id="Initial-Info-container">
          <div id="button-navigation-container">
            <span><a href="#initInfo-background-info">B</a></span>
            <span><a href="#initInfo-test-score-info">T</a></span>
            <span><a href="#initInfo-subjective-scoring-info">S</a></span>
            <span><a href="#initInfo-introduction-info">I</a></span>
          </div>
          <h2>Initial Information</h2>
          <div id="initInfo-background-info" class="info-box">
            <div id="initInfo-grid">
              <div>Date of Birth:</div>
              <div>School/Hospital Name:</div>
              <div>05/21/2012</div>
              <div>Health Medical Center</div>
              <div>Age:</div>
              <div>Program:</div>
              <div>12</div>
              <div>Speech and Language Therapy</div>
              <div>Cognitive Age:</div>
              <div>Program Type:</div>
              <div>8</div>
              <div>Social Skills</div>
              <div>Parent/Guardian1:</div>
              <div>Grade:</div>
              <div>John Smith</div>
              <div>5th</div>
              <div>Parent/Guardian1 Phone:</div>
              <div>Buildings/Room:</div>
              <div>(###) ###-####</div>
              <div>BD212</div>
              <div>Parent/Guardian1 Email:</div>
              <div>Teacher:</div>
              <div>guardian1.gmail.com</div>
              <div>Jane Doe</div>
              <div>Parent/Guardian2:</div>
              <div>Address:</div>
              <div>Mary Smith</div>
              <div>1234 Street Ave</div>
              <div>Parent/Guardian2 Phone:</div>
              <div>Med#/Student ID:</div>
              <div>(###) ###-####</div>
              <div>1efs564cd89</div>
              <div>Parent/Guardian2 Email:</div>
              <div>Custom ID:</div>
              <div>guardian2.gmail.com</div>
              <div>ef4654xcef5</div>
              <div>Case Manager:</div>
              <div>Consent Sign Date:</div>
              <div>Jane Roe</div>
              <div>9/8/2020</div>
            </div>
          </div>
          <div class="accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button">
              History/Background Information
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content">
              <div class="accordion-inner-content">
                <textarea placeholder="Enter history/background information here..."></textarea>
              </div>
            </div>  
          </div>
          <div class="accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button">
              Reason for Referall
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content">
              <div class="accordion-inner-content">
                <textarea placeholder="Enter reason for referral here..."></textarea>
              </div>
            </div>  
          </div>
          <div class="accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button">
              Previous External Tests
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content">
              <div class="accordion-inner-content">
                <textarea placeholder="Enter previous external tests here..."></textarea>
              </div>
            </div>  
          </div>
          <div class="accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button">
              Review of Records
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content">
              <div class="accordion-inner-content">
                <textarea placeholder="Enter review of records here..."></textarea>
              </div>
            </div>  
          </div>
          <div class="accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button">
              Culture and Linguistic Factors
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content">
              <div class="accordion-inner-content">
                <textarea placeholder="Enter culture and linguistic factors here..."></textarea>
              </div>
            </div>  
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center; margin: 1rem 0">
            <h5 id="initInfo-introduction-info">Introduction</h5>
            <div style="display: flex; align-items: center">
              <div style="margin-right: 15px">Auto-Fill</div>
              <label class="toggle-slider-container">
                <input type="checkbox">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="info-box">
            A __ in __ shirt was seen for evaluation of __type questions were included in the screening
          </div>
          <h5 id="initInfo-subjective-scoring-info" style="margin-top: 1rem">
            Subjective Scoring
          </h5>
          <div id="subjective-scoring-container" class="info-box">
            <div>
              <div style="display: flex; justify-content: space-between">
                Comprehension
                <b-form-checkbox v-model="keyToFactor.subScore.list.compreh.optsOut" true-value="true" false-value="false">
                  Opt-Out
                </b-form-checkbox>
              </div>
              <div class="custom-slider-container">
                <input v-model="keyToFactor.subScore.list.compreh.variable" type="range" min="1" max="10" value="1" id="range" step="1" />
                <div class="track"></div>
                <div class="sliderticks">
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                  <span>8</span>
                  <span>9</span>
                  <span>10</span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex; justify-content: space-between">
                Problem Solving
                <b-form-checkbox v-model="keyToFactor.subScore.list.probSolv.optsOut" true-value="true" false-value="false">
                  Opt-Out
                </b-form-checkbox>
              </div>
              <div class="custom-slider-container">
                <input v-model="keyToFactor.subScore.list.probSolv.variable" type="range" min="1" max="10" value="1" id="range" step="1" />
                <div class="track"></div>
                <div class="sliderticks">
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                  <span>8</span>
                  <span>9</span>
                  <span>10</span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex; justify-content: space-between">
                Intelligibility
                <b-form-checkbox v-model="keyToFactor.subScore.list.intell.optsOut" true-value="true" false-value="false">
                  Opt-Out
                </b-form-checkbox>
              </div>
              <div class="custom-slider-container">
                <input v-model="keyToFactor.subScore.list.intell.variable" type="range" min="1" max="10" value="1" id="range" step="1" />
                <div class="track"></div>
                <div class="sliderticks">
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                  <span>8</span>
                  <span>9</span>
                  <span>10</span>
                </div>
              </div>
            </div>
          </div>
          <h5 id="initInfo-test-score-info" style="margin-top: 1rem">
            Test Score
          </h5>
          <div id="top-categ-skipped-container" class="info-box">
            Top Category Skipped
            <div>{{dataDetails.mostSkippedCategoryObject.name}}</div>
            Category Amount Skipped
            <div>{{dataDetails.mostSkippedCategoryObject.amount}}</div>
          </div>
          <div id="strong-weak-categ-container" class="info-box">
            Strongest Category
            <div>{{dataDetails.strongestCategory}}</div>
            Weakest Category
            <div>{{dataDetails.weakestCategory}}</div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showTestScore" id="Test-Scores-container">
          <div>
            <h2>Test Scores</h2>
            <div id="strongest-weakest-category-container">
              <div class="grid-container">
                <div>
                  Strongest Category
                  <div>{{dataDetails.strongestCategory}}</div>
                </div>
                <div>
                  Weakest Category
                  <div>{{dataDetails.weakestCategory}}</div>
                </div>
              </div>
            </div>
            <div id="change-default-category-button-row-container">
              <div>
                <div id="leftPill" :class="[showRegVariables.testScoreDefault ? 'selectedPillHalf':null, 'left-half', 'half-pill']" @click="selectPill('left')">Default</div>
                <div id="rightPill" :class="[!showRegVariables.testScoreDefault ? 'selectedPillHalf':null, 'right-half', 'half-pill']" @click="selectPill('right')">A category at a time</div>
              </div>
            </div>

            <div v-if="showRegVariables.testScoreDefault" id="default-view-test-scores-container">
              <div class="info-box">
                <h6>Details</h6>
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>ID</th>
                      <th>Media</th>
                      <th>Question</th>
                      <th>P/H/R/OT</th>
                      <th>Category</th>
                      <th>Note</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in data" :key="value.id" :style="{backgroundColor: applyTableRowColor(value)}">
                      <td>{{ index+1 }}</td>
                      <td>...{{ value.question_id.slice(-4) }}</td>
                      <td class="media-icons-container">
                        <span>
                          <span class="red-dot" v-if="value.video_clips.length !== 0"></span>
                          <font-awesome-icon :icon="['fas', 'video']" />
                        </span>
                        <span>
                          <span class="red-dot" v-if="value.audio_clips.length !== 0"></span>
                          <font-awesome-icon :icon="['fas', 'headphones']" />
                        </span>
                        <span>
                          <span class="red-dot" v-if="value.video_clips.length !== 0"></span>
                          <font-awesome-icon :icon="['fas', 'camera']" />
                        </span>
                      </td>
                      <td>{{ value.question_text }}</td>
                      <td>{{ `${value.prompt_count}/${value.hint_count}/${value.repeat_count}/${value.over_time}` }}</td>
                      <td>{{ value.category }}</td>
                      <td>{{ value.notes }}</td>
                      <td>{{ value.skipped ? 'N/A' : `${value.selected_score}/${value.highest_possible_score}` }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="info-box">
                <h6>Scores</h6>
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Raw Score</th>
                      <th>Percentile</th>
                      <th>Standard Score</th>
                      <th>Age Equivalent</th>
                      <th>Quotient</th>
                      <th>Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in categorizedDataInfo.groupedData" :key="index">
                      <td>{{item.details.categoryName}}</td>
                      <td>{{item.details.rawScore}}</td>
                      <td>{{item.details.percentile}}th</td>
                      <td>{{item.details.standardScore}}</td>
                      <td>{{item.details.ageEquivalent}}</td>
                      <td>{{(item.details.quotient).toFixed(2)}}</td>
                      <td>{{item.details.rating}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-5 info-box">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    Observer & Impression Comments
                  </div>
                  <b-form-checkbox v-model="keyToFactor.obserComments.optsOut" true-value="true" false-value="false">
                    Opt-out
                  </b-form-checkbox>
                </div>
                <div>
                  <textarea placeholder="Enter observer comments here..." v-model="keyToFactor.obserComments.variable"></textarea>
                </div>
              </div>
            </div>
            <div v-else id="categ-view-test-scores-container">
              <div class="gridParent-categ">
                <div>
                  <div class="categ-navigation-container">
                    <font-awesome-icon :icon="['fas', 'caret-left']" style="cursor: pointer;" @click="rotateCategory('left')"/>
                    <h3>{{ categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.categoryName }}</h3>
                    <font-awesome-icon :icon="['fas', 'caret-right']" style="cursor: pointer;" @click="rotateCategory('right')"/>
                  </div>
                  <div class="info-box">
                    <h4>Scores</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>Raw Score</th>
                          <th>Percentile</th>
                          <th>Scaled Score</th>
                          <th>Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.rawScore}}</td>
                          <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.percentile}}th</td>
                          <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.quotient.toFixed(2)}}</td>
                          <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.rating}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="info-box">
                    <h4>Assessement Details</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>ID</th>
                          <th>Media</th>
                          <th>Question</th>
                          <th>P/H/R/OT</th>
                          <th>Note</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, index) in categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].categoryQuestions" :key="value.id" :style="{backgroundColor: applyTableRowColor(value)}">
                          <td>{{ index+1 }}</td>
                          <td>...{{ value.question_id.slice(-4) }}</td>
                          <td>
                            <div class="d-flex">
                              <font-awesome-icon :icon="['fas', 'video']" class="m-1"/>
                              <font-awesome-icon :icon="['fas', 'headphones']" class="m-1"/>
                              <font-awesome-icon :icon="['fas', 'camera']" class="m-1"/>
                            </div>
                          </td>
                          <td>{{ value.question_text }}</td>
                          <td>{{ `${value.prompt_count}/${value.hint_count}/${value.repeat_count}/${value.over_time}` }}</td>
                          <td>{{ value.notes }}</td>
                          <td>{{ value.skipped ? 'N/A' : `${value.selected_score}/${value.highest_possible_score}` }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="info-box">
                  <h4>Observation</h4>
                  <textarea v-model="keyToFactor.categComments.list[`categComment` + `${categorizedDataInfo.groupedDataIndex}`].variable"></textarea>
                  <b-form-checkbox v-model="keyToFactor.categComments.list[`categComment` + `${categorizedDataInfo.groupedDataIndex}`].optsOut" true-value="true" false-value="false">
                    Opt-out
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showAttention" id="Attention-Emotion-container">
          <h2>Attention & Emotion</h2>
          <div class="info-box">
            <div>
              <div>
                {{ keyToFactor.atteSocEmoFunc.label }}
              </div>
              <b-form-checkbox v-model="keyToFactor.atteSocEmoFunc.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <textarea placeholder="Enter text here..." v-model="keyToFactor.atteSocEmoFunc.variable"></textarea>
          </div>
          <div class="info-box">
            <div>
              <div>
                {{ keyToFactor.riskSum.label }}
              </div>
              <b-form-checkbox v-model="keyToFactor.riskSum.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <textarea placeholder="Enter text here..." v-model="keyToFactor.riskSum.variable"></textarea>
          </div>
        </div>
        <div v-else-if="showNavVariables.showGraphs" id="Graphs-Plots-container">
          <h2>Graphs & Plots</h2>
          <h4>Diagram</h4>
          <div class="radioGrid-container">
            <div>Types:</div>
            <div v-for="(item) in plotVariables.plotSelect" :key="item.label">
              <span @click="chooseGraphics(item.label)">
                <span :class="[keyToFactor[item.ref].optsOut ? 'categGraphOptedOut' : null ,item.isActive ? 'categGraphSelected' : null, 'categGraphOptions']"></span>
                {{ item.label }}
              </span>
            </div>
            <div>Categories:</div>
            <div @click="chooseGraphics('worse 3')">
              <div class="categGraphOptions" id="selectWorst3Opt"></div>
              Weakest 3
            </div>
            <div @click="chooseGraphics('all')">
              <div class="categGraphOptions" id="selectAllOpt"></div>
              All
            </div>
          </div>
          <div v-if="keyToFactor.barChart.worst.isActive && !keyToFactor.barChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Bar Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <BarChartECharts :dataInput="usedDataBarChartWorst" />
                <div :class="['plotDrop-sideBar', keyToFactor.barChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.barChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.barChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.barChart.worst.outlierValues[0]}, ${keyToFactor.barChart.worst.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.barChart.worst.worstData" group="barChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataBarChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.barChart.worst.worstDataRemoved" group="barChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataBarChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.barChart.all.isActive && !keyToFactor.barChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Bar Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <BarChartECharts :dataInput="usedDataBarChartAll" />
                <div :class="['plotDrop-sideBar', keyToFactor.barChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.barChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.barChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.barChart.all.outlierValues[0]}, ${keyToFactor.barChart.all.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.barChart.all.allData" group="barChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataBarChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.barChart.all.allDataRemoved" group="barChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataBarChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.scattPlot.worst.isActive && !keyToFactor.scattPlot.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Scatter Plot: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <ScatterPlotECharts :dataInput="usedDataScattPlotWorst" />
                <div :class="['plotDrop-sideBar', keyToFactor.scattPlot.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.scattPlot.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.scattPlot.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.scattPlot.worst.outlierValues[0]}, ${keyToFactor.scattPlot.worst.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.scattPlot.worst.worstData" group="scattPlotWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataScattPlotWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.scattPlot.worst.worstDataRemoved" group="scattPlotWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataScattPlotWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.scattPlot.all.isActive && !keyToFactor.scattPlot.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Scatter Plot: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <ScatterPlotECharts :dataInput="usedDataScattPlotAll" />
                <div :class="['plotDrop-sideBar', keyToFactor.scattPlot.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.scattPlot.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.scattPlot.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.scattPlot.all.outlierValues[0]}, ${keyToFactor.scattPlot.all.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.scattPlot.all.allData" group="scattPlotAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataScattPlotAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.scattPlot.all.allDataRemoved" group="scattPlotAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataScattPlotAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.radarChart.worst.isActive && !keyToFactor.radarChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Radar Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <RadarChartECharts :dataInput="usedDataRadarChartWorst" />
                <div :class="['plotDrop-sideBar', keyToFactor.radarChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.radarChart.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.radarChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.radarChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.radarChart.worst.outlierValues[0]}, ${keyToFactor.radarChart.worst.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.radarChart.worst.worstData" group="radarChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataRadarChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.radarChart.worst.worstDataRemoved" group="radarChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataRadarChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.radarChart.all.isActive && !keyToFactor.radarChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Radar Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <RadarChartECharts :dataInput="usedDataRadarChartAll" />
                <div :class="['plotDrop-sideBar', keyToFactor.radarChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.radarChart.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.radarChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.radarChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.radarChart.all.outlierValues[0]}, ${keyToFactor.radarChart.all.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.radarChart.all.allData" group="radarChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataRadarChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.radarChart.all.allDataRemoved" group="radarChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataRadarChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="keyToFactor.pieChart.worst.isActive && !keyToFactor.pieChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Pie Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <PieChartECharts :dataInput="usedDataPieChartWorst" />
                <div :class="['plotDrop-sideBar', keyToFactor.pieChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.pieChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.pieChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.pieChart.worst.outlierValues[0]}, ${keyToFactor.pieChart.worst.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.pieChart.worst.worstData" group="pieChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataPieChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.pieChart.worst.worstDataRemoved" group="pieChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataPieChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.pieChart.all.isActive && !keyToFactor.pieChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Pie Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <PieChartECharts :dataInput="usedDataPieChartAll" />
                <div :class="['plotDrop-sideBar', keyToFactor.pieChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.pieChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.pieChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.pieChart.all.outlierValues[0]}, ${keyToFactor.pieChart.all.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.pieChart.all.allData" group="pieChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataPieChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.pieChart.all.allDataRemoved" group="pieChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataPieChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.lineChart.worst.isActive && !keyToFactor.lineChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Line Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <LineChartECharts :dataInput="usedDataLineChartWorst" />
                <div :class="['plotDrop-sideBar', keyToFactor.lineChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.lineChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.lineChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.lineChart.worst.outlierValues[0]}, ${keyToFactor.lineChart.worst.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.lineChart.worst.worstData" group="lineChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataLineChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.lineChart.worst.worstDataRemoved" group="lineChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataLineChartWorst" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="keyToFactor.lineChart.all.isActive && !keyToFactor.lineChart.optsOut" class="plotDrop-container accordion-container">
            <button @click="e => toggleAccordion(e)" class="accordion-button secondary-color-button-sm-global">
              Line Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </button>
            <div class="accordion-content plotDrop-content-container">
              <div>
                <LineChartECharts :dataInput="usedDataLineChartAll" />
                <div :class="['plotDrop-sideBar', keyToFactor.lineChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.lineChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.lineChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 1rem; font-size: 1.2rem;">{{ `[${keyToFactor.lineChart.all.outlierValues[0]}, ${keyToFactor.lineChart.all.outlierValues[1]}]` }}</div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.lineChart.all.allData" group="lineChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataLineChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.lineChart.all.allDataRemoved" group="lineChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataLineChartAll" :key="index" class="plotDrop-drag-category">
                          {{ `${index+1}) ${item.variable}: ${item.value}%` }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showSummary" id="Summary-Recomm-container">
          <h2>Summary & Recommendations</h2>
          <div class="title-opt-container">
            <h4>{{ keyToFactor.summConclus.label }}</h4>
            <b-form-checkbox v-model="keyToFactor.summConclus.optsOut" true-value="true" false-value="false">
              Opt-out
            </b-form-checkbox>
          </div>
          <textarea v-model="keyToFactor.summConclus.variable"></textarea>
          <div class="title-opt-container">
            <h4>{{ keyToFactor.techDetail.label }}-Additional Comments</h4>
            <b-form-checkbox v-model="keyToFactor.techDetail.optsOut" true-value="true" false-value="false">
              Opt-out
            </b-form-checkbox>
          </div>
          <div style="margin-top: 1rem">
            <span class="mr-5">Browser: {{ browserInfo.name }}</span>
            <span class="mr-5">Version: {{browserInfo.version}}</span>
            <span class="mr-5">Hardware: Unknown</span>
          </div>
          <div class="title-opt-container">
            <h4>Technology - Additional Comments</h4>
            <b-form-checkbox v-model="keyToFactor.additComments.optsOut" true-value="true" false-value="false">
              Opt-out
            </b-form-checkbox>
          </div>
          <textarea v-model="keyToFactor.techDetail.variable"></textarea>
        </div>
        <div v-else-if="showNavVariables.showRootCause" id="Root-Cause-Analysis-container">
          <h2>Root Cause Analysis</h2>
          <div class="mt-5">
            <div class="nav-button-group">
              <button @click="physicalMappingButton" class="primary-button-sm-global">Physical Mapping</button>
              <button @click="compareSimiliarButton" class="primary-button-sm-global">Compare Similiar</button>
              <button @click="compareSettingsButton" class="primary-button-sm-global">Comparison Settings</button>
              <button class="primary-button-sm-global">Edit</button>
            </div>
            <div>
              Coming Soon
            </div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showConfig" id="Config-Order-container">
          <h2>Configure Order</h2>
          <div style="margin-top: 2rem;">
            The following items will appear in the report. <br> You may drag items to customize the order of items to display.
          </div>
          <div style="margin-top: 1rem;">
            <draggable v-model="list">
              <div v-for="(item, index) in list" :key="index" >
                <div class="drag-item">
                  <div :class="[keyToFactor[item.ref].optsOut?'drag-item-deactivated':null]">=</div>
                  <div :style="index % 2 != 0 ? 'color: #5A5A5A' : ''" :class="[keyToFactor[item.ref].optsOut?'drag-item-deactivated':null]">{{ item.label }}</div>
                  <b-form-checkbox v-model="keyToFactor[item.ref].optsOut" true-value="true" false-value="false">Opt Out</b-form-checkbox>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </section>
    </div>
    <div v-else id="Preview-container">
      <button class="primary-button-sm-global" @click="closePreview">Close Preview</button>
      <button class="primary-button-sm-global" style="margin-left: 5px;" @click="exportPDF">Export SVGs to PDF</button>

      <div id="example-pdf-html-container">
        <div id="title-report-container">
          <svg
            width="3829"
            height="1395"
            viewBox="0 0 3829 1395"
            version="1.1"
            id="neuroleaplogo"
            sodipodi:docname="logo_no_r.svg"
            inkscape:version="1.3.2 (091e20e, 2023-11-25, custom)"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg">
            <defs
              id="defs2" />
            <path
              d="m 2880.9884,155.70605 c -36.089,3.581 -67.462,11.588 -100.194,25.569 -48.131,20.559 -91.051,53.138 -124.417,94.439 -9.344,11.567 -30.143,41.489 -29.374,42.259 0.208,0.207 4.127,-0.542 8.709,-1.665 24.255,-5.945 50.119,-5.125 73.566,2.331 46.748,14.865 89.77,56.46 128.65,124.382 17.099,29.872 43.225,94.585 57.594,142.659 7.336,24.547 15.388,60.18 16.676,73.802 0.353,3.74 0.988,6.44 1.41,6 0.715,-0.749 8.372,-29.872 34.389,-130.802 5.813,-22.55 11.689,-45.275 13.059,-50.5 2.977,-11.36 19.266,-74.42 26.476,-102.5 2.824,-11 9.567,-37.1 14.984,-58 17.316,-66.808 28.891,-111.578 32.896,-127.226 2.819,-11.019 3.583,-15.466 2.764,-16.096 -1.654,-1.272 -18.447,-7.514 -31.132,-11.57 -37.498,-11.992 -86.159,-17.042 -126.056,-13.082 m 230.106,68.656 c -0.502,1.503 -9.135,34.234 -47.035,178.318 -6.799,25.85 -13.269,50.375 -14.377,54.5 -1.107,4.125 -7.933,30 -15.168,57.5 -19.243,73.139 -33.266,126.348 -36.898,140 -1.756,6.6 -7.692,29.1 -13.192,50 -5.501,20.9 -11.543,43.85 -13.428,51 -11.503,43.637 -13.208,50.5 -12.541,50.5 2.363,0 25.096,-4.485 33.476,-6.604 19.539,-4.941 48.815,-15.945 67.735,-25.457 37.9,-19.056 76.493,-50.212 103.977,-83.939 22.356,-27.435 35.729,-49.615 49.189,-81.585 19.958,-47.406 28.875,-101.981 24.657,-150.915 -2.249,-26.089 -7.435,-53.778 -13.51,-72.126 -15.827,-47.808 -33.73,-80.071 -65.403,-117.86 -14.743,-17.591 -46.425,-46.503 -47.482,-43.332 m -418.326,168.89 c -26.055,2.518 -59.772,19.238 -93.224,46.228 -15.974,12.888 -15.078,11.426 -16.176,26.39 -2.605,35.5 4.245,84.222 17.065,121.373 24.793,71.855 70.533,130.036 135.111,171.862 26.61,17.235 70.345,35.433 102,42.442 22.007,4.873 63,9.507 63,7.123 0,-0.443 -3.046,-4.222 -6.768,-8.398 -3.723,-4.176 -9.111,-10.34 -11.974,-13.698 l -5.206,-6.105 -2.005,-21.895 c -11.953,-130.535 -40.427,-234.928 -83.558,-306.35 -10.513,-17.408 -14.367,-22.72 -22.059,-30.403 -16.907,-16.888 -35.904,-26.487 -56.631,-28.614 -5.506,-0.565 -10.301,-0.966 -10.655,-0.891 -0.354,0.075 -4.368,0.496 -8.92,0.936"
              stroke="none"
              fill="#f3a304"
              fill-rule="evenodd"
              id="path1" />
            <g
              id="g2"
              transform="translate(-42.455639,-389.81995)">
              <path
                d="m 3119.028,426.148 c -1.179,2.714 -5.141,17.095 -8.5,30.852 -1.276,5.225 -3.986,15.8 -6.023,23.5 -2.036,7.7 -4.772,18.275 -6.079,23.5 -1.307,5.225 -2.95,11.337 -3.651,13.583 l -1.275,4.083 -10.5,-3.959 c -41.07,-15.486 -82.012,-22.686 -129,-22.686 -29.464,0 -50.769,2.079 -77.858,7.6 -99.816,20.341 -190.262,85.124 -243.363,174.311 -9.821,16.495 -20.906,38.737 -26.844,53.863 l -4.435,11.295 -11,8.335 c -10.19,7.72 -49.598,42.668 -50.319,44.624 -0.175,0.475 0.443,3.696 1.374,7.158 0.931,3.461 2.721,10.568 3.978,15.793 1.257,5.225 5.289,21.2 8.96,35.5 3.672,14.3 7.714,30.275 8.983,35.5 3.64,14.986 4.866,19.439 5.595,20.325 0.373,0.453 2.872,-2.894 5.554,-7.439 l 4.875,-8.263 0.747,6.938 c 4.855,45.097 11.122,73.289 23.437,105.439 48.69,127.106 160.028,218.006 291.359,237.877 21.741,3.29 37.886,4.292 64.192,3.983 18.406,-0.216 25.046,0.021 25.95,0.925 1.633,1.633 2.815,1.533 2.815,-0.24 0,-1.574 0.044,-1.584 18.5,-4.082 61.17,-8.278 120.063,-33.009 171.668,-72.09 76.163,-57.679 128.797,-144.309 144.23,-237.386 4.008,-24.176 4.987,-36.556 5.018,-63.487 0.05,-42.318 -5.038,-76.858 -16.836,-114.3 -23.019,-73.054 -71.851,-141.754 -133.404,-187.683 -7.524,-5.615 -9.225,-7.35 -8.806,-8.988 2.966,-11.603 6.728,-25.927 7.801,-29.705 l 1.329,-4.675 11.023,10.675 c 21.184,20.516 49.874,43.977 67.977,55.587 3.3,2.116 7.575,4.854 9.5,6.084 1.925,1.23 6.425,3.903 10,5.941 3.575,2.037 7.175,4.099 8,4.581 6.892,4.026 26.49,12.666 39,17.193 45.313,16.399 96.398,18.157 141.5,4.869 19.228,-5.665 27.015,-8.097 29,-9.059 1.1,-0.533 4.667,-1.942 7.927,-3.132 3.259,-1.19 7.479,-3.08 9.377,-4.2 l 3.452,-2.036 -0.733,-55.076 c -0.403,-30.292 -0.867,-55.22 -1.031,-55.396 -0.164,-0.176 -2.171,0.724 -4.46,2 -2.288,1.276 -7.17,3.998 -10.847,6.048 -24.542,13.688 -67.292,32.815 -82.185,36.772 -2.475,0.658 -4.95,1.549 -5.5,1.981 -0.55,0.433 -4.915,1.741 -9.699,2.908 -4.785,1.167 -9.893,2.576 -11.353,3.131 -1.46,0.555 -10.37,2.406 -19.801,4.114 -36.689,6.643 -73.568,4.597 -103.147,-5.721 -34.352,-11.984 -58.487,-29.116 -91.107,-64.67 -19.088,-20.806 -41.596,-47.913 -48.79,-58.758 -1.282,-1.933 -3.056,-4.116 -3.942,-4.851 -1.388,-1.152 -1.753,-1.012 -2.633,1.014 M 80.396,615.5 c 0.336,62.15 1.081,230.675 1.656,374.5 0.575,143.825 1.272,262.573 1.549,263.884 l 0.504,2.384 47.442,-0.461 c 26.093,-0.254 47.747,-0.768 48.122,-1.142 0.374,-0.374 0.114,-112.99 -0.577,-250.257 -0.692,-137.267 -1.085,-249.748 -0.874,-249.959 0.21,-0.211 107.531,114.915 238.49,255.834 130.959,140.919 239.246,257.282 240.639,258.585 l 2.532,2.367 -0.45,-32.367 C 659.181,1221.065 658.276,1050.8 657.418,860.5 656.56,670.2 655.679,513.938 655.461,513.25 655.15,512.273 644.649,512 607.387,512 h -47.675 l 0.64,61.25 c 0.353,33.688 0.914,147.65 1.249,253.25 l 0.607,192 -2.97,-3 C 557.604,1013.85 450.626,899.325 321.508,761 192.391,622.675 85.182,507.925 83.267,506 l -3.482,-3.5 0.611,113 m 2029.854,-110.794 -90.25,0.305 -0.01,22.244 c -0.028,72.863 3.172,716.487 3.568,717.629 0.403,1.161 8.202,1.31 48.452,0.925 26.385,-0.252 48.286,-0.773 48.671,-1.157 0.384,-0.385 -0.533,-144.967 -2.039,-321.295 -1.506,-176.328 -2.586,-320.747 -2.402,-320.932 0.185,-0.185 41.044,-0.639 90.798,-1.009 95.103,-0.707 102.064,-0.499 123.784,3.692 46.799,9.031 86.488,36.952 104.231,73.326 6.825,13.989 9.052,23.098 9.673,39.566 0.611,16.179 -0.948,25.451 -6.81,40.5 -12.027,30.878 -33.185,53.951 -62.417,68.068 -16.058,7.754 -45.4,14.634 -79,18.522 -6.065,0.701 -38.007,1.403 -81.168,1.783 -39.142,0.345 -71.401,0.861 -71.686,1.146 -0.452,0.454 273.096,384.027 280.164,392.851 l 2.7,3.369 59.693,-0.869 59.694,-0.87 -107.233,-154.5 -107.232,-154.5 10.511,-0.732 c 25.503,-1.776 57.479,-10.513 77.057,-21.054 53.697,-28.912 95.024,-75.534 111.907,-126.245 12.407,-37.266 13.304,-77.101 2.577,-114.469 -16.676,-58.095 -61.342,-109.642 -119.93,-138.407 -27.417,-13.461 -53.845,-21.372 -87.554,-26.208 -13.08,-1.876 -56.825,-2.217 -215.75,-1.679 m -290.881,97.544 c 1.618,248.334 1.835,369.275 0.679,379.75 -4.28,38.797 -19.293,75.588 -42.438,104 -30.879,37.906 -75.76,63.673 -122.958,70.595 -15.741,2.309 -46.865,1.547 -62.031,-1.518 -49.284,-9.96 -96.475,-42.03 -124.01,-84.276 -7.603,-11.663 -17.762,-32.866 -22.065,-46.05 -3.702,-11.343 -6.741,-24.966 -8.534,-38.251 -0.712,-5.271 -1.555,-88.175 -2.472,-243 -0.765,-129.25 -1.425,-235.113 -1.465,-235.25 -0.041,-0.137 -21.489,-0.25 -47.661,-0.25 h -47.586 l 0.682,173.25 c 0.375,95.288 1.064,204.3 1.53,242.25 0.752,61.189 1.072,70.415 2.826,81.5 8.472,53.533 28.199,98.783 60.815,139.5 11.442,14.283 35.016,37.952 48.319,48.512 50.447,40.045 111.016,60.967 176.5,60.967 56.946,0 110.397,-15.831 156.12,-46.24 75.756,-50.381 122.864,-130.732 130.297,-222.239 0.904,-11.134 -0.534,-475.057 -1.483,-478.25 -0.29,-0.977 -10.768,-1.25 -48.032,-1.25 h -47.661 l 0.628,96.25 M 965.5,510.262 c -112.2,0.503 -204.159,1.071 -204.352,1.262 -0.673,0.662 2.992,738.98 3.671,739.677 0.761,0.781 459.627,-1.013 467.931,-1.829 l 5.25,-0.516 v -46.959 c 0,-38.776 -0.238,-47.051 -1.366,-47.484 -0.752,-0.288 -85.689,-0.149 -188.75,0.31 -103.061,0.459 -187.609,0.672 -187.884,0.473 -0.352,-0.255 -1.802,-223.993 -1.464,-225.899 0.02,-0.111 65.045,-0.561 144.5,-1 l 144.464,-0.797 0.307,-38 c 0.169,-20.9 0.01,-42.678 -0.356,-48.394 l -0.663,-10.395 -144.229,0.739 -144.229,0.738 -0.664,-63.844 c -0.365,-35.114 -0.665,-85.483 -0.665,-111.93 L 857,608.327 l 53.25,-0.662 c 29.288,-0.365 76.463,-0.663 104.835,-0.664 28.371,-10e-4 89.459,-0.3 135.75,-0.666 L 1235,605.671 v -22.086 c -10e-4,-12.147 -0.298,-33.897 -0.661,-48.335 l -0.658,-26.25 -32.089,0.173 c -17.65,0.096 -123.89,0.586 -236.09,1.089 m 1957.944,35.264 c -36.089,3.581 -67.462,11.588 -100.194,25.569 -48.131,20.559 -91.051,53.138 -124.417,94.439 -9.344,11.567 -30.143,41.489 -29.374,42.259 0.208,0.207 4.127,-0.542 8.709,-1.665 24.255,-5.945 50.119,-5.125 73.566,2.331 46.748,14.865 89.77,56.46 128.65,124.382 17.099,29.872 43.225,94.585 57.594,142.659 7.336,24.547 15.388,60.18 16.676,73.802 0.353,3.74 0.988,6.44 1.41,6 0.715,-0.749 8.372,-29.872 34.389,-130.802 5.813,-22.55 11.689,-45.275 13.059,-50.5 2.977,-11.36 19.266,-74.42 26.476,-102.5 2.824,-11 9.567,-37.1 14.984,-58 17.316,-66.808 28.891,-111.578 32.896,-127.226 2.819,-11.019 3.583,-15.466 2.764,-16.096 -1.654,-1.272 -18.447,-7.514 -31.132,-11.57 -37.498,-11.992 -86.159,-17.042 -126.056,-13.082 m 230.106,68.656 c -0.502,1.503 -9.135,34.234 -47.035,178.318 -6.799,25.85 -13.269,50.375 -14.377,54.5 -1.107,4.125 -7.933,30 -15.168,57.5 -19.243,73.139 -33.266,126.348 -36.898,140 -1.756,6.6 -7.692,29.1 -13.192,50 -5.501,20.9 -11.543,43.85 -13.428,51 -11.503,43.637 -13.208,50.5 -12.541,50.5 2.363,0 25.096,-4.485 33.476,-6.604 19.539,-4.941 48.815,-15.945 67.735,-25.457 37.9,-19.056 76.493,-50.212 103.977,-83.939 22.356,-27.435 35.729,-49.615 49.189,-81.585 19.958,-47.406 28.875,-101.981 24.657,-150.915 -2.249,-26.089 -7.435,-53.778 -13.51,-72.126 -15.827,-47.808 -33.73,-80.071 -65.403,-117.86 -14.743,-17.591 -46.425,-46.503 -47.482,-43.332 m -418.326,168.89 c -26.055,2.518 -59.772,19.238 -93.224,46.228 -15.974,12.888 -15.078,11.426 -16.176,26.39 -2.605,35.5 4.245,84.222 17.065,121.373 24.793,71.855 70.533,130.036 135.111,171.862 26.61,17.235 70.345,35.433 102,42.442 22.007,4.873 63,9.507 63,7.123 0,-0.443 -3.046,-4.222 -6.768,-8.398 -3.723,-4.176 -9.111,-10.34 -11.974,-13.698 l -5.206,-6.105 -2.005,-21.895 c -11.953,-130.535 -40.427,-234.928 -83.558,-306.35 -10.513,-17.408 -14.367,-22.72 -22.059,-30.403 -16.907,-16.888 -35.904,-26.487 -56.631,-28.614 -5.506,-0.565 -10.301,-0.966 -10.655,-0.891 -0.354,0.075 -4.368,0.496 -8.92,0.936 m -711.557,537.595 c -0.367,0.366 -0.667,92.391 -0.667,204.5 V 1729 h 130 130 v -35 -35 h -94 -94 V 1489.5 1320 h -35.333 c -19.434,0 -35.634,0.3 -36,0.667 m 454,0 c -0.367,0.366 -0.667,92.391 -0.667,204.5 V 1729 h 130 130 v -35 -35 h -94 -94 v -49.5 -49.5 h 70.5 70.5 v -35.5 -35.5 h -70.5 -70.5 v -49 -49 h 94 94 v -35.5 -35.5 h -129.333 c -71.134,0 -129.634,0.3 -130,0.667 m 626.086,-0.045 c -1.171,1.963 -188.753,407.199 -188.753,407.765 0,0.337 17.438,0.611 38.75,0.609 h 38.75 l 12.67,-27.246 12.67,-27.246 h 82.757 82.756 l 12.074,27.247 12.073,27.246 h 38.714 38.715 l -1.847,-4.25 c -8.17,-18.798 -177.448,-402.564 -178.039,-403.628 -0.422,-0.759 -1.002,-0.984 -1.29,-0.5 m 358.946,0.013 c -0.385,0.384 -0.699,92.423 -0.699,204.532 V 1729 h 35.75 l 35.75,10e-4 -0.31,-78.935 -0.31,-78.935 51.31,-0.409 c 47.758,-0.381 51.998,-0.558 61.253,-2.548 44.99,-9.676 79.453,-34.93 97.937,-71.768 8.624,-17.186 11.945,-31.341 11.945,-50.906 0,-19.808 -3.572,-34.862 -12.325,-51.939 -16.074,-31.362 -43.274,-53.776 -80,-65.923 -21.687,-7.174 -19.865,-7.056 -114.551,-7.396 -46.779,-0.168 -85.366,0.01 -85.75,0.393 M 3533,1445.44 V 1500 l 45.25,-0.035 c 47.714,-0.037 53.891,-0.489 66.182,-4.841 9.25,-3.276 16.304,-7.942 25.128,-16.624 9.086,-8.94 12.539,-15.036 14.446,-25.5 3.943,-21.638 -8.658,-42.56 -32.506,-53.974 -15.417,-7.379 -15.277,-7.363 -69.75,-7.777 l -48.75,-0.37 v 54.561 m -455.759,100.237 c -13.892,30.152 -25.254,55.161 -25.249,55.573 0,0.412 22.331,0.75 49.615,0.75 39.293,0 49.5,-0.26 49.094,-1.25 -0.283,-0.687 -10.716,-24.425 -23.186,-52.75 -12.471,-28.325 -23.201,-52.771 -23.845,-54.323 -1.111,-2.676 -2.495,0.047 -26.429,52"
                stroke="none"
                fill="#040404"
                fill-rule="evenodd"
                id="path2" />
            </g>
          </svg>

          <h2>Application Report</h2>
        </div>
        <hr />

        <div id="pdf-content">
          <div style="display: grid; grid-template-columns: auto auto auto auto; gap: 8px 16px; max-width: 800px; font-family: sans-serif; font-size: 14px; padding: 16px; border: 1px solid #ccc; background-color: #fdfdfd; align-items: baseline; border-radius: 5px; margin-bottom: 20px;">
            <div style="font-weight: bold; color: #333; white-space: nowrap;">Patient Name:</div>
            <div style="color: #000; grid-column: span 3;">Jane Doe</div>

            <div style="font-weight: bold; color: #333; white-space: nowrap;">Date of Birth:</div>
            <div style="color: #000;">1990-03-14</div>
            <div style="font-weight: bold; color: #333; white-space: nowrap;">Age:</div>
            <div style="color: #000;">35</div>

            <div style="font-weight: bold; color: #333; white-space: nowrap;">Sex:</div>
            <div style="color: #000;">Female</div>
            <div style="font-weight: bold; color: #333; white-space: nowrap;">Patient ID:</div>
            <div style="color: #000;">12345678</div>

            <div style="font-weight: bold; color: #333; white-space: nowrap;">Date of Report:</div>
            <div style="color: #000;">2025-07-26</div>
            <div style="font-weight: bold; color: #333; white-space: nowrap;">Referring Physician:</div>
            <div style="color: #000;">Dr. John Smith</div>
          </div>

          <div style="display: grid; grid-template-columns: auto auto auto auto; gap: 8px 16px; max-width: 800px; font-family: sans-serif; font-size: 14px; padding: 16px; border: 1px solid #ccc; background-color: #fdfdfd; align-items: baseline; border-radius: 5px;">
            <div style="font-weight: bold; color: #333; white-space: nowrap;">Application ID</div>
            <div style="color: #000; grid-column: span 3;">ed929021-2fda-4645-89e7-672766cca03c</div>

            <div style="font-weight: bold; color: #333; white-space: nowrap;">Application Name</div>
            <div style="color: #000; grid-column: span 3;">Acuity Severity Questionnaire</div>

            <div style="font-weight: bold; color: #333; white-space: nowrap;">Duration</div>
            <div style="color: #000; grid-column: span 3;">00:13:30</div>

            <div style="font-weight: bold; color: #333; white-space: nowrap;">Date Started:</div>
            <div style="color: #000;">2025-07-26</div>
            <div style="font-weight: bold; color: #333; white-space: nowrap;">Date Completed:</div>
            <div style="color: #000;">2025-07-27</div>
          </div>
        </div>

        <div v-for="(item, index) in listDisplayTextBoxes" :key="index">
          <div v-if="listDisplayTextBoxes[index].label == 'Bar Chart'">
            <div id="print-barChartVerticalWorst">
              <BarChartECharts ref="barChartEChartWorstRef" :dataInput="usedDataBarChartWorst" />
            </div>

            <div id="print-barChartHorizontalAll">
              <BarChartECharts ref="barChartEChartAllRef" :dataInput="usedDataBarChartAll" />
            </div>
          </div>
          <div v-else-if="listDisplayTextBoxes[index].label == 'Scatter Plot'">
            <div id="print-scatterPlotWorst">
              <ScatterPlotECharts ref="scatterPlotEChartWorstRef" :dataInput="usedDataScattPlotWorst" />
            </div>

            <div id="print-scatterPlotAll">
              <ScatterPlotECharts ref="scatterPlotEChartAllRef" :dataInput="usedDataScattPlotAll" />
            </div>
          </div>
          <div v-else-if="listDisplayTextBoxes[index].label == 'Radar Chart'">
            <div id="print-radarChartWorst">
              <RadarChartECharts ref="radarChartEChartWorstRef" :dataInput="usedDataRadarChartWorst" />
            </div>

            <div id="print-radarChartAll">
              <RadarChartECharts ref="radarChartEChartAllRef" :dataInput="usedDataRadarChartAll" />
            </div>
          </div>
          <div v-else-if="listDisplayTextBoxes[index].label == 'Pie Chart'">
            <div id="print-pieChartWorst">
              <PieChartECharts ref="pieChartEChartWorstRef" :dataInput="usedDataPieChartWorst" />
            </div>

            <div id="print-pieChartAll">
              <PieChartECharts ref="pieChartEChartAllRef" :dataInput="usedDataPieChartAll" />
            </div>
          </div>
          <div v-else-if="listDisplayTextBoxes[index].label == 'Line Chart'">
            <div id="print-lineChartWorst">
              <LineChartECharts ref="lineChartEChartWorstRef" :dataInput="usedDataLineChartWorst" />
            </div>

            <div id="print-lineChartAll">
              <LineChartECharts ref="lineChartEChartsAllRef" :dataInput="usedDataLineChartAll" />
            </div>
          </div>
          <div v-if="listDisplayTextBoxes[index].label == 'Category Comments'">
            <div v-for="(categ, _, index2) in listDisplayTextBoxes[index].list" :id="`${categ.label}-text`" class="tester" :key=index2>
              {{ categ.label }}
              <div>{{ categ.variable }}</div>
            </div>
          </div>
          <div v-else-if="'variable' in listDisplayTextBoxes[index]" :id="`${listDisplayTextBoxes[index].label}-text`" class="tester">
            {{ item.label }}
            <div>{{ item.variable }}</div>
          </div>
          <div v-else-if="listDisplayTextBoxes[index].label == 'Test Score'">
            Test
          </div>
          <div v-else-if="listDisplayTextBoxes[index].label == 'Subjective Scoring'">
            <div id="print-totalScoreCircle">
              <DonutChartECharts ref="donutChartRef" :skipped="3" :incorrect="5" :correct="12" />
            </div>
          </div>

        </div>

      </div>

    </div>
	</div>
</template>

<script>
  import draggable from 'vuedraggable';

  import LineChartECharts from './LineChartECharts.vue';
  import ScatterPlotECharts from './ScatterPlotECharts.vue';
  import BarChartECharts from './BarChartECharts.vue';
  import RadarChartECharts from './RadarChartECharts.vue';
  import PieChartECharts from './PieChartECharts.vue';
  import DonutChartECharts from './DonutChartECharts.vue';

  import jsPDF from "jspdf";
  import 'jspdf-autotable';

  import instance from '../../axios.js';
  import { v4 as uuidv4 } from 'uuid';

	export default {
    props: {
      applicationID: {
        type: String,
        required: true
      }
    },
    components: {
      LineChartECharts,
      ScatterPlotECharts,
      BarChartECharts,
      RadarChartECharts,
      PieChartECharts,
      DonutChartECharts,
      draggable,
    },
    data() {
      return {  
        data: null,
        browserInfo: {name: null, version: null},
        screenWidth: null,
        preferredName: 'Phil Thomson',
        appSubtitle: 'null',
        includeCateg: 'null',
        dataDetails: {
          weakestCategory: null,
          strongestCategory: null,
          correctScore: null,
          incorrectScore: null,
          skippedScore: null,
          maxScore: null,
          numberCorrectQuestions: null,
          numberIncorrectQuestions: null,
          numberSkippedQuestions: null,
          numberQuestions: null,
          mostSkippedCategoryObject: {
            name: null,
            amount: null
          },
        },
        modalData: {
          moreQuestionInfo: null,
        },
        profilePic: null,
        profilePicTemp: null,
        orderedScoresByCateg: null,
        listDisplayTextBoxes: null,
        keyToFactor: {
          subScore: {
            label: "Subjective Scoring",
            optsOut: false,
            list:{ 
              compreh: {label: 'Comprehension', variable: 'N/A', optsOut: false},
              probSolv: {label: 'Problem Solving', variable: 'N/A', optsOut: false},
              intell: {label: 'Intelligibility', variable: 'N/A', optsOut: false}
            },
            dropDownMood: {
              selectedValue: 'Select Mood',
              isDropdownOpen: false,
              options: ['tense', 'excited', 'cheerful', 'relaxed', 'calm', 'bored', 'sad', 'irrated', 'neutral'],
            },
            dropDownShirtColor: {
              selectedValue: 'Select Shirt Color',
              isDropdownOpen: false,
              options: ['red', 'green', 'blue', 'orange', 'yellow', 'indigo', 'violet'],
            },
          },
          additComments: {
            label: "Additional Comments",
            variable: null,
            optsOut: false
          },
          categComments: {
            label: "Category Comments",
            optsOut: false,
            list: {}
          },
          barChart: {
            label: "Bar Chart",
            optsOut: false,
            worst: {
              ref: 'barChartWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
              dropDownWeakest: {
                selectedValue: 'Weakest Three Categories',
                isDropdownOpen: false,
                options: ['Weakest Category', 'Weakest Two Categories', 'Weakest Three Categories'],
              },
              pastChoose: [
                {label: "past 1 month",isActive: true},
                {label: "past 3 months",isActive: false},
                {label: "past 1 year",isActive: false},
                {label: "past 3 years",isActive: false},
                {label: "all",isActive: false},
              ],
            },
            all: {
              ref: 'barChartAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          scattPlot: {
            label: "Scatter Plot",
            optsOut: false,
            worst: {
              ref: 'scattPlotWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              ref: 'scattPlotAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          lineChart: {
            label: "Line Chart",
            optsOut: false,
            worst: {
              ref: 'lineChartWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              ref: 'lineChartAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          pieChart: {
            label: "Pie Chart",
            optsOut: false,
            worst: {
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              isActive: true,
              allData: null,
              allDataRemoved: [],
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          radarChart: {
            label: "Radar Chart",
            optsOut: false,
            worst: {
              ref: 'radarChartWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              ref: 'radarChartAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          obserComments: {
            label: "Observation + Impression Comments",
            variable: null,
            optsOut: false
          },
          atteSocEmoFunc: {
            label: "Attention, Social & Emotional Functioning",
            variable: null,
            optsOut: false
          },
          riskSum: {
            label: "Risk Summary",
            variable: null,
            optsOut: false
          },
          summConclus: {
            label: "Summary of Conclusion",
            variable: null,
            optsOut: false
          },
          furthTask: {
            label: "Furthur Task + Recommendation",
            variable: null,
            optsOut: false
          },
          accomInstru: {
            label: "Accommodation",
            variable: null,
            optsOut: false
          },
          techDetail: {
            label: "Technology Details",
            variable: null,
            optsOut: false
          },
          testScore: {
            label: "Test Score",
            optsOut: true
          }
        },
        list: [
          {label: 'Subjective scoring (intelligibility, comprehension etc)', ref: 'subScore'},
          {label: 'Bar chart', ref: 'barChart'},
          {label: 'Scatter plot', ref: 'scattPlot'},
          {label: 'Line chart', ref: 'lineChart'},
          {label: 'Pie chart', ref: 'pieChart'},
          {label: 'Radar chart', ref: 'radarChart'},
          {label: 'Additional Comments', ref: 'additComments'},
          {label: 'Category Comments', ref: 'categComments'},
          {label: 'Observations & Impression (for each category typically)', ref: 'obserComments'},
          {label: 'Attention, Emotions & Social Functioning (mood i.e.)', ref: 'atteSocEmoFunc'},
          {label: 'Risk Summary', ref: 'riskSum'},
          {label: 'Summary of Conclusion', ref: 'summConclus'},
          {label: 'Futher testing and Recommendation', ref: 'furthTask'},
          {label: 'Accommodation and Instruction', ref: 'accomInstru'},
          {label: 'Technology details (AAC device i.e.)', ref: 'techDetail'},
          {label: 'Test Score', ref: 'testScore'},
        ],
        dragOptions: {
          animation: 200,
        },
        sliders: {
          data: ['N/A', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
          process: () => [
            [0, 10, { backgroundColor: '#878587' }],
            [10, 50, { backgroundColor: '#E69D95' }],
            [50, 80, { backgroundColor: '#FFF9AA' }],
            [80, 100, { backgroundColor: '#9AE69F' }]
          ],
        },
        showRegVariables: {
          testScoreDefault: true,
          preview: false,
        },
        showNavVariables: {
          showInitInfo: true,
          showConfig: false,
          showTestScore: false,
          showAttention: false,
          showGraphs: false,
          showSummary: false,
          showRootCause: false,
          toggleNavSelect: "showInitInfo",
        },
        categorizedDataInfo: {
          groupedDataIndex: 0,
          numberOfCateg: null,
          groupedData: null,
        },
        nestedGrouping: null,
        plotVariables: {
          plotSelect: {
            barChart: {label: "Bar Chart", isActive: false, ref: 'barChart'},
            scattPlot: {label: "Scatter Plot", isActive: false, ref: 'scattPlot'},
            radarChart: {label: "Radar Chart", isActive: false, ref: 'radarChart'},
            pieChart: {label: "Pie Chart", isActive: false, ref: 'pieChart'},
            lineChart: {label: "Line Chart", isActive: false, ref: 'lineChart'}
          },
        },
      }
    },
    async created() {
      try {
        let response = await instance.get(`/api/question-admin/application/${this.applicationID}`);
        let responseData = response.data;
        let questionExampleResult = [];
        
        for (let i = 0; i < responseData.length; i++) {
          questionExampleResult.push({
            report_id: uuidv4(),
            question_id: uuidv4(),
            application_id: uuidv4(),
            question_text: responseData[i].question,
            area: responseData[i].area,
            type: responseData[i].type,
            category: responseData[i].category,
            sub_category: responseData[i].sub_category,
            notes: "Answer carefully.",
            selected_score: this.getRandomIntInclusive(0, responseData[i].highest_score_possible),
            highest_possible_score: responseData[i].highest_score_possible,
            child_selected_answer: ['A', 'B', 'C'],
            correct_answer: ['B'],
            audio_clips: [],
            video_clips: [],
            picture_clips: [],
            prompt_clicks: this.getRandomIntInclusive(0, 10),
            repeat_clicks: this.getRandomIntInclusive(0, 5),
            total_duration: '00:05:30',
            ecg: this.getRandomIntInclusive(0, 100),
            emg: 'N/A | N/A',
            motor_sensor_left: this.getRandomIntInclusive(0, 100),
            motor_sensor_right: this.getRandomIntInclusive(0, 100),
            prompt_count: this.getRandomIntInclusive(0, 10),
            hint_count: this.getRandomIntInclusive(0, 5),
            repeat_count: this.getRandomIntInclusive(0, 3),
            over_time: '00:00:00',
            skipped: Math.random() > 0.9
          })
        }
        this.data = questionExampleResult;

        this.screenWidth = window.innerWidth;
        this.browserInfo = this.getBrowserInfo();

        for (let i = 0; i < this.list.length; i++) {
          this.list[i].letter = `${String.fromCharCode(i+65)}`
        }

        //group questions by category and tally points
        let categorizedQuestions = {};
        let correctScore = 0;
        let skippedScore = 0;
        let maxScore = 0;
        let numberCorrectQuestions = 0;
        let numberskippedQuestions = 0;
        this.numberQuestions = this.data.length;
        this.data.forEach(item => {
          if (item.skipped) {
            skippedScore += item.highest_possible_score;
            numberskippedQuestions += 1;
          } else {
            if (item.selected_score == item.highest_possible_score) {
              numberCorrectQuestions += 1;
            }
            correctScore += item.selected_score;
          }
          maxScore += item.highest_possible_score;

          if (!categorizedQuestions[item.category]) {
            categorizedQuestions[item.category] = {
              details: {},
              categoryQuestions: []
            };
          }
          categorizedQuestions[item.category].categoryQuestions.push(item);
        });
        this.dataDetails.correctScore = correctScore;
        this.dataDetails.incorrectScore = maxScore - correctScore - skippedScore;
        this.dataDetails.skippedScore = skippedScore;
        this.dataDetails.maxScore = maxScore;
        this.dataDetails.numberCorrectQuestions = numberCorrectQuestions;
        this.dataDetails.numberIncorrectQuestions = this.numberQuestions - numberCorrectQuestions - numberskippedQuestions;
        this.dataDetails.numberSkippedQuestions = numberskippedQuestions;
        
        categorizedQuestions = Object.values(categorizedQuestions);
        this.categorizedDataInfo.groupedData = categorizedQuestions;
        this.categorizedDataInfo.numberOfCateg = this.categorizedDataInfo.groupedData.length;

        let nestedGrouping = {};
        this.data.forEach(question => {
          if (!nestedGrouping[question.area]) {
            nestedGrouping[question.area] = {
              details: {
                area: question.area,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              typeQuestions: {}
            };
          }
          let detailsArea = nestedGrouping[question.area].details;
          detailsArea.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsArea.maxPoints += question.highest_possible_score;
          detailsArea.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsArea.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          if (!nestedGrouping[question.area].typeQuestions[question.type]) {
            nestedGrouping[question.area].typeQuestions[question.type] = {
              details: {
                type: question.type,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              categoryQuestions: {}
            }
          }
          let detailsType = nestedGrouping[question.area].typeQuestions[question.type].details;
          detailsType.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsType.maxPoints += question.highest_possible_score;
          detailsType.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsType.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          if (!nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category]) {
            nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category] = {
              details: {
                category: question.category,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              subCategoryQuestions: {}
            }
          }
          let detailsCategory = nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].details;
          detailsCategory.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsCategory.maxPoints += question.highest_possible_score;
          detailsCategory.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsCategory.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          if (!nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category]) {
            nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category] = {
              details: {
                subCategory: question.sub_category,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              Questions: []
            }
          }
          let detailsSubCategory = nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category].details;
          detailsSubCategory.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsSubCategory.maxPoints += question.highest_possible_score;
          detailsSubCategory.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsSubCategory.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category].Questions.push(question);
        });
        this.nestedGrouping = nestedGrouping;

        //set variables for each category
        for (let i = 0; i < categorizedQuestions.length; i++) {
          this.$set(this.keyToFactor.categComments.list, `categComment` + `${i}`, 
            {variable: null, label: this.categorizedDataInfo.groupedData[i].categoryQuestions[0].category, optsOut: false}
          );
        }

        //sort by totalscore in ascending order if tie then sort by numofquestions in descending order
        let scoreArray = [];
        let categoryScorePoints;
        let maxScorePoints;
        let categorySkippedPoints;
        let categoryQuestionsSkipped;
        let categoryMostSkipped = {
          name: null,
          amount: 0,
        };
        for (const item of this.categorizedDataInfo.groupedData) {
          categoryScorePoints = 0;
          maxScorePoints = 0;
          categorySkippedPoints = 0;
          categoryQuestionsSkipped = 0;
          for (const question of item.categoryQuestions) {
            categoryScorePoints += question.selected_score;
            maxScorePoints += question.highest_possible_score;
            categorySkippedPoints += question.highest_possible_score;
            if (question.skipped) {
              categoryQuestionsSkipped += 1;
            }
          }

          if (categoryMostSkipped.amount <= categoryQuestionsSkipped) {
            categoryMostSkipped.name = item.categoryQuestions[0].category;
            categoryMostSkipped.amount = categoryQuestionsSkipped;
          }

          item.details = {
            ...item.details,
            categoryName: item.categoryQuestions[0].category,
            rawScore: categoryScorePoints,
            percentile: Math.floor(Math.random() * 101),
            standardScore: ((categoryScorePoints - (categoryScorePoints + 10))/3).toFixed(2),
            ageEquivalent: 'Some Age',
            quotient: (categoryScorePoints/maxScorePoints),
            rating: Math.floor(Math.random() * 101),
            numOfQuestions: item.categoryQuestions.length,
            skippedPoints: categorySkippedPoints
          }
          scoreArray.push({name: item.categoryQuestions[0].category, quotient: ((categoryScorePoints/maxScorePoints)*100), numOfQuestions: item.categoryQuestions.length});
        }

        this.dataDetails.mostSkippedCategoryObject = categoryMostSkipped;

        scoreArray.sort((a, b) => { 
          if (a.quotient !== b.quotient) {
            return a.quotient - b.quotient;
          }
          else {
            return b.numOfQuestions - a.numOfQuestions
          }
        });

        this.dataDetails.weakestCategory = scoreArray[0].name;
        this.dataDetails.strongestCategory = scoreArray[scoreArray.length-1].name;

        //make & set graph data for alldata and worstdata
        let graphDataWorst = [];
        let graphDataWorstRemoved = [];
        let graphDataAll = scoreArray.map(obj => {  //{variable, value}
          return {variable: obj.name, value: obj.quotient.toFixed(2)};
        })
        if (scoreArray.length >= 3) {
          graphDataWorst = graphDataAll.slice(0,3);
          graphDataWorstRemoved = graphDataAll.slice(3,scoreArray.length);
        }
        else {
          graphDataWorst = graphDataAll.slice(0,scoreArray.length);
        }

        Object.values(this.plotVariables.plotSelect).forEach(item => {
          this.keyToFactor[item.ref].all.allData = [...graphDataAll];
          this.keyToFactor[item.ref].worst.worstData = [...graphDataWorst];
          this.keyToFactor[item.ref].worst.worstDataRemoved = [...graphDataWorstRemoved];
        });
        this.orderedScoresByCateg = [...graphDataAll];
      } catch (e) {
        console.error(e);
      }
    },
    watch: {
      'showNavVariables.showGraphs': function(newV) {
        if (newV) {
          for (const key in this.plotVariables.plotSelect) {
            this.plotVariables.plotSelect[key].isActive = false;
          }
        }
      }
    },
    computed: {
      usedDataBarChartAll() {
        let temp = [...this.keyToFactor.barChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.barChart.all.outlierValues[0] && element.value <= this.keyToFactor.barChart.all.outlierValues[1]));
      },
      removedDataBarChartAll() {
        let temp = [...this.keyToFactor.barChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.barChart.all.outlierValues[0] && element.value <= this.keyToFactor.barChart.all.outlierValues[1]));
      },
      usedDataScattPlotAll() {
        let temp = [...this.keyToFactor.scattPlot.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.all.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.all.outlierValues[1]));
      },
      removedDataScattPlotAll() {
        let temp = [...this.keyToFactor.scattPlot.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.all.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.all.outlierValues[1]));
      },
      usedDataRadarChartAll() {
        let temp = [...this.keyToFactor.radarChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.all.outlierValues[0] && element.value <= this.keyToFactor.radarChart.all.outlierValues[1]));
      },
      removedDataRadarChartAll() {
        let temp = [...this.keyToFactor.radarChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.all.outlierValues[0] && element.value <= this.keyToFactor.radarChart.all.outlierValues[1]));
      },
      usedDataPieChartAll() {
        let temp = [...this.keyToFactor.pieChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.all.outlierValues[0] && element.value <= this.keyToFactor.pieChart.all.outlierValues[1]));
      },
      removedDataPieChartAll() {
        let temp = [...this.keyToFactor.pieChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.all.outlierValues[0] && element.value <= this.keyToFactor.pieChart.all.outlierValues[1]));
      },
      usedDataLineChartAll() {
        let temp = [...this.keyToFactor.lineChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.all.outlierValues[0] && element.value <= this.keyToFactor.lineChart.all.outlierValues[1]));
      },
      removedDataLineChartAll() {
        let temp = [...this.keyToFactor.lineChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.all.outlierValues[0] && element.value <= this.keyToFactor.lineChart.all.outlierValues[1]));
      },
      usedDataBarChartWorst() {
        let temp = [...this.keyToFactor.barChart.worst.worstData];
        let newV = this.keyToFactor.barChart.worst.dropDownWeakest.selectedValue;
        temp = temp.filter(element => (element.value >= this.keyToFactor.barChart.worst.outlierValues[0] && element.value <= this.keyToFactor.barChart.worst.outlierValues[1]));
        temp.sort((a, b) => a.value - b.value);
        if (newV == 'Weakest Category') {
          return temp.slice(0,1);
        }
        else if (newV == 'Weakest Two Categories') {
          return temp.slice(0,2);
        }
        else {
          return temp.slice(0,3);
        }
      },
      removedDataBarChartWorst() {
        let temp = [...this.keyToFactor.barChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.barChart.worst.outlierValues[0] && element.value <= this.keyToFactor.barChart.worst.outlierValues[1]));
      },
      usedDataScattPlotWorst() {
        let temp = [...this.keyToFactor.scattPlot.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.worst.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.worst.outlierValues[1]));
      },
      removedDataScattPlotWorst() {
        let temp = [...this.keyToFactor.scattPlot.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.worst.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.worst.outlierValues[1]));
      },
      usedDataRadarChartWorst() {
        let temp = [...this.keyToFactor.radarChart.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.worst.outlierValues[0] && element.value <= this.keyToFactor.radarChart.worst.outlierValues[1]));
      },
      removedDataRadarChartWorst() {
        let temp = [...this.keyToFactor.radarChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.worst.outlierValues[0] && element.value <= this.keyToFactor.radarChart.worst.outlierValues[1]));
      },
      usedDataPieChartWorst() {
        let temp = [...this.keyToFactor.pieChart.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.worst.outlierValues[0] && element.value <= this.keyToFactor.pieChart.worst.outlierValues[1]));
      },
      removedDataPieChartWorst() {
        let temp = [...this.keyToFactor.pieChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.worst.outlierValues[0] && element.value <= this.keyToFactor.pieChart.worst.outlierValues[1]));
      },
      usedDataLineChartWorst() {
        let temp = [...this.keyToFactor.lineChart.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.worst.outlierValues[0] && element.value <= this.keyToFactor.lineChart.worst.outlierValues[1]));
      },
      removedDataLineChartWorst() {
        let temp = [...this.keyToFactor.lineChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.worst.outlierValues[0] && element.value <= this.keyToFactor.lineChart.worst.outlierValues[1]));
      },
    },
    methods: {
      backToAppConfig() {
        this.$emit('backToAppConfig');
      },
      getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      getBrowserInfo() {
        let ua = navigator.userAgent;
        let name, version;

        if (ua.indexOf("Chrome") !== -1) {
            name = "Google Chrome";
            version = ua.match(/Chrome\/([\d.]+)/)[1];
        } else if (ua.indexOf("Firefox") !== -1) {
            name = "Mozilla Firefox";
            version = ua.match(/Firefox\/([\d.]+)/)[1];
        } else if (ua.indexOf("Safari") !== -1) {
            name = "Safari";
            version = ua.match(/Version\/([\d.]+)/)[1];
        } else if (ua.indexOf("MSIE") !== -1 || ua.indexOf("Trident") !== -1) {
            name = "Internet Explorer";
            version = ua.match(/(?:MSIE |rv:)(\d+(\.\d+)?)/)[1];
        } else {
            name = "Unknown Browser";
            version = "N/A";
        }

        return {
            name: name,
            version: version.trim()
        };
      },
      toggleAllNavShows(variable) {
        this.showNavVariables.showTestScore = variable === "showTestScore";
        this.showNavVariables.showAttention = variable === "showAttention";
        this.showNavVariables.showSummary = variable === "showSummary";
        this.showNavVariables.showConfig = variable === "showConfig";
        this.showNavVariables.showInitInfo = variable === "showInitInfo";
        this.showNavVariables.showGraphs = variable === "showGraphs";
        this.showNavVariables.showRootCause = variable == "showRootCause";
        this.showNavVariables.toggleNavSelect = variable;
      },
      selectPill(side) {
        if (side == "left") {
          document.getElementById("leftPill").classList.add('selectedPillHalf');
          document.getElementById("rightPill").classList.remove('selectedPillHalf');
          this.showRegVariables.testScoreDefault = true;
        }
        else {
          document.getElementById("leftPill").classList.remove('selectedPillHalf');
          document.getElementById("rightPill").classList.add('selectedPillHalf');
          this.showRegVariables.testScoreDefault = false;
        }
      },
      rotateCategory(direction) {
        function positModulo(dividend, divisor) {
          return ((dividend % divisor) + divisor) % divisor;
        }
        const categArrayLength = this.categorizedDataInfo.groupedData.length;
        if (direction == "left") {
          this.categorizedDataInfo.groupedDataIndex = positModulo(this.categorizedDataInfo.groupedDataIndex - 1,categArrayLength);
        }
        else {
          this.categorizedDataInfo.groupedDataIndex = positModulo(this.categorizedDataInfo.groupedDataIndex + 1,categArrayLength);
        }
      },
      showPreview() {
        this.showRegVariables.preview = true;
        let tempArray = this.list.filter(element => this.keyToFactor[element.ref].optsOut == false);
        this.listDisplayTextBoxes = tempArray.map(element => this.keyToFactor[element.ref]);
      },
      closePreview() {
        this.showRegVariables.preview = false;
      },
      async exportPDF() {
        async function chartAdd(chart, pdf, currentCoordsOfPDFPage, a4Dimensions, pagePadding) {
          if (!chart || !pdf) throw new Error('chart and pdf instances are required');

          // Get base64 PNG image from chart
          const base64Image = chart.getDataURL({
            type: 'png',
            pixelRatio: 2,
            backgroundColor: '#fff'
          });

          // Load image to get natural size
          const img = await new Promise(resolve => {
            const image = new Image();
            image.src = base64Image;
            image.onload = () => resolve(image);
          });

          // Max width/height for chart inside page with padding
          const maxWidth = a4Dimensions.width - 2 * pagePadding;
          const maxHeight = a4Dimensions.height - 2 * pagePadding;

          // Calculate scaled dimensions to fit inside maxWidth/maxHeight while keeping aspect ratio
          let imgWidth = maxWidth;
          let imgHeight = (img.naturalHeight / img.naturalWidth) * imgWidth;

          if (imgHeight > maxHeight) {
            imgHeight = maxHeight;
            imgWidth = (img.naturalWidth / img.naturalHeight) * imgHeight;
          }

          if (currentCoordsOfPDFPage.y+imgHeight + 5 > a4Dimensions.height - pagePadding) {
            pdf.addPage("a4", "portrait");
            currentCoordsOfPDFPage.y = pagePadding;
          }

          // Add the image at calculated position and size
          pdf.addImage(base64Image, 'PNG', currentCoordsOfPDFPage.x, currentCoordsOfPDFPage.y, imgWidth, imgHeight);

          currentCoordsOfPDFPage.y += imgHeight + 10;
        }

        function textBoxAdd(object, pdf, currentCoordsOfPDFPage, a4Dimensions, pagePadding) {
          const boxPaddingVertical = 0.5; // very small vertical padding inside the box
          const boxPaddingHorizontal = 2;
          const boxMarginBottom = 5;
          const boxWidth = a4Dimensions.width - pagePadding * 2;
          const labelFontSize = 12;
          const valueFontSize = 10;

          // === Label text height ===
          pdf.setFontSize(labelFontSize);
          pdf.setFont(undefined, "bold");
          // getLineHeightFactor usually ~1.15, reduce effective height by a bit
          const labelTextHeight = labelFontSize * (pdf.getLineHeightFactor() * 0.85);

          // === Variable text height ===
          pdf.setFontSize(valueFontSize);
          pdf.setFont(undefined, "normal");
          const variableText = object.variable || '';
          const textAreaWidth = boxWidth - boxPaddingHorizontal * 2;

          const splitVariableText = pdf.splitTextToSize(variableText, textAreaWidth);
          const variableDimensions = pdf.getTextDimensions(splitVariableText);
          let variableTextHeight = variableDimensions.h * 0.85; // slightly reduce height

          if (!variableText.trim()) {
            variableTextHeight = labelTextHeight * 0.5;
          }

          // Less padding between label and variable text, only if variable text exists
          const paddingBetweenLabelAndVariable = variableText.trim() ? 4 : 0;

          // Total box height: padding + label + padding + variable + padding
          const totalBoxHeight = boxPaddingVertical + labelTextHeight + paddingBetweenLabelAndVariable + variableTextHeight + boxPaddingVertical;

          // New page check
          if (currentCoordsOfPDFPage.y + totalBoxHeight > a4Dimensions.height - pagePadding) {
            pdf.addPage("a4", "portrait");
            currentCoordsOfPDFPage.y = pagePadding;
          }

          // Draw box
          pdf.setDrawColor(128);
          pdf.setLineWidth(0.3);
          pdf.setFillColor(253, 253, 253);
          pdf.roundedRect(
            currentCoordsOfPDFPage.x,
            currentCoordsOfPDFPage.y,
            boxWidth,
            totalBoxHeight,
            1.5, 1.5,
            "FD"
          );

          // Label text Y (adjust -1 removed for less offset)
          const labelY = currentCoordsOfPDFPage.y + boxPaddingVertical + labelTextHeight * 0.9;
          pdf.setFontSize(labelFontSize);
          pdf.setFont(undefined, "bold");
          pdf.text(
            object.label,
            currentCoordsOfPDFPage.x + boxPaddingHorizontal,
            labelY
          );

          // Variable text Y
          if (variableText.trim()) {
            const variableY = labelY + paddingBetweenLabelAndVariable;
            pdf.setFontSize(valueFontSize);
            pdf.setFont(undefined, "normal");
            pdf.text(
              splitVariableText,
              currentCoordsOfPDFPage.x + boxPaddingHorizontal,
              variableY
            );
          }

          // Move Y down
          currentCoordsOfPDFPage.y += totalBoxHeight + boxMarginBottom;
        }

        async function svgAdd(id, pdf, currentCoordsOfPDFPage, a4Dimensions, pagePadding, width) {
          const svgEl = document.getElementById(id);
          if (!svgEl) {
            console.warn(`SVG element with id "${id}" not found`);
            return currentCoordsOfPDFPage;
          }

          // Serialize the SVG to string
          const svgData = new XMLSerializer().serializeToString(svgEl);
          const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
          const url = URL.createObjectURL(svgBlob);

          return new Promise((resolve) => {
            const img = new Image();
            img.onload = function () {
              const canvas = document.createElement('canvas');
              canvas.width = img.width;
              canvas.height = img.height;

              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);

              const imgData = canvas.toDataURL('image/png');

              // Calculate height to keep aspect ratio based on passed width
              const aspectRatio = img.height / img.width;
              const displayWidth = width;
              const displayHeight = displayWidth * aspectRatio;

              // Add image to PDF
              pdf.addImage(
                imgData,
                'PNG',
                pagePadding,
                currentCoordsOfPDFPage.y,
                displayWidth,
                displayHeight
              );

              URL.revokeObjectURL(url);

              currentCoordsOfPDFPage.y += displayHeight + 5;
              // Return updated Y position
              resolve({
                x: currentCoordsOfPDFPage.x,
                y: currentCoordsOfPDFPage.y + displayHeight + 5,
              });
            };

            img.src = url;
          });
        }

        try {
          const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
          });
          pdf.setFont("times", "normal");

          const a4Dimensions = {width: 210, height: 297};
          let pagePadding = 25;
          let contentMaxWidthMm = a4Dimensions.width - pagePadding * 2;
          let currentCoordsOfPDFPage = {x: pagePadding, y: pagePadding};
          pdf.text("text", 0, 0);

          await svgAdd("neuroleaplogo", pdf, currentCoordsOfPDFPage, a4Dimensions, pagePadding, 40);

          pdf.setFontSize(30);
          const textWidth = pdf.getTextWidth('Application Report');
          pdf.text('Application Report', ((a4Dimensions.width - textWidth) / 2) + 10, pagePadding + 10);

          pdf.setDrawColor(136, 136, 136);
          pdf.setLineWidth(0.5);
          pdf.line(
            currentCoordsOfPDFPage.x,
            currentCoordsOfPDFPage.y,
            currentCoordsOfPDFPage.x + 160,
            currentCoordsOfPDFPage.y
          );
          currentCoordsOfPDFPage.y += 5;

          let patientInfoEl = document.getElementById("pdf-content");
          let elWidthPx = patientInfoEl.offsetWidth;
          let pxToMm = (px) => (px * 25.4) / 96;
          let elWidthMm = pxToMm(elWidthPx);
          let scale = contentMaxWidthMm / elWidthMm;
          let elHeightPx = patientInfoEl.offsetHeight;
          let elHeightMm = pxToMm(elHeightPx) * scale;

          await pdf.html(patientInfoEl, {
            x: currentCoordsOfPDFPage.x,
            y: currentCoordsOfPDFPage.y,
            width: 160,
            windowWidth: patientInfoEl.offsetWidth,
          });

          currentCoordsOfPDFPage.y += elHeightMm + 5;

          for (let i = 0; i < this.listDisplayTextBoxes.length; i++) {
            if (this.listDisplayTextBoxes[i].label == 'Bar Chart') {
              if (this.keyToFactor.barChart.worst.isActive) {
                await chartAdd(this.$refs.barChartEChartWorstRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
              if (this.keyToFactor.barChart.all.isActive) {
                await chartAdd(this.$refs.barChartEChartAllRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
            }
            else if (this.listDisplayTextBoxes[i].label == 'Scatter Plot') {
              if (this.keyToFactor.scattPlot.worst.isActive) {
                await chartAdd(this.$refs.scatterPlotEChartWorstRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
              if (this.keyToFactor.scattPlot.all.isActive) {
                await chartAdd(this.$refs.scatterPlotEChartAllRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
            }
            else if (this.listDisplayTextBoxes[i].label == 'Radar Chart') {
              if (this.keyToFactor.radarChart.worst.isActive) {
                await chartAdd(this.$refs.radarChartEChartWorstRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
              if (this.keyToFactor.radarChart.all.isActive) {
                await chartAdd(this.$refs.radarChartEChartAllRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
            }
            else if (this.listDisplayTextBoxes[i].label == 'Pie Chart') {
              if (this.keyToFactor.pieChart.worst.isActive) {
                await chartAdd(this.$refs.pieChartEChartWorstRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
              if (this.keyToFactor.pieChart.all.isActive) {
                await chartAdd(this.$refs.pieChartEChartAllRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
            }
            else if (this.listDisplayTextBoxes[i].label == 'Line Chart') {
              if (this.keyToFactor.lineChart.worst.isActive) {
                await chartAdd(this.$refs.lineChartEChartWorstRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
              if (this.keyToFactor.lineChart.all.isActive) {
                await chartAdd(this.$refs.lineChartEChartsAllRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
            }
            else if (this.listDisplayTextBoxes[i].label == 'Category Comments') {
              for (const item in this.listDisplayTextBoxes[i].list) {
                await textBoxAdd(this.listDisplayTextBoxes[i].list[item], pdf, currentCoordsOfPDFPage, a4Dimensions, pagePadding);
              }
            }
            else if ('variable' in this.listDisplayTextBoxes[i]) {
              await textBoxAdd(this.listDisplayTextBoxes[i], pdf, currentCoordsOfPDFPage, a4Dimensions, pagePadding);
            }
            if (this.listDisplayTextBoxes[i].label == 'Test Score') {
              //await chartAdd(document.getElementById('print-totalScoreCircle').firstElementChild,pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
            }
            else if (this.listDisplayTextBoxes[i].label == 'Subjective Scoring') {
              await chartAdd(this.$refs.donutChartRef[0].getChartInstance(),pdf,currentCoordsOfPDFPage, a4Dimensions, pagePadding);
            }
          }
          const pdfBlob = pdf.output('blob');
          const pdfBlobUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfBlobUrl);
          URL.revokeObjectURL(pdfBlobUrl);
        } catch (e) {
          console.error(e);
        }
      },
      chooseGraphics(label) {
        const threeRef = document.getElementById('selectWorst3Opt');
        const allRef = document.getElementById('selectAllOpt');

        //categories selection
        if (label === "worse 3" || label === "all") {
          let shortenRef = this.plotVariables.plotSelect;
          for (const item in shortenRef) {
            if (shortenRef[item].isActive && !this.keyToFactor[item].optsOut) {
              if (label === "worse 3") {
                this.keyToFactor[shortenRef[item].ref].worst.isActive = !this.keyToFactor[shortenRef[item].ref].worst.isActive;
                threeRef.classList.toggle('categGraphSelected');
              }
              else {
                this.keyToFactor[shortenRef[item].ref].all.isActive = !this.keyToFactor[shortenRef[item].ref].all.isActive;
                allRef.classList.toggle('categGraphSelected');
              }
              return;
            }
          }
        }
        else {
          //types selection
          let shortenRef = this.plotVariables.plotSelect;
          for (let item in shortenRef) {
            if (shortenRef[item].label === label) {
              if (this.keyToFactor[shortenRef[item].ref].optsOut) {
                return;
              }
            }
            shortenRef[item].isActive = shortenRef[item].label === label;
            if (shortenRef[item].isActive) {
              this.keyToFactor[shortenRef[item].ref].worst.isActive ? threeRef.classList.add('categGraphSelected') : threeRef.classList.remove('categGraphSelected');
              this.keyToFactor[shortenRef[item].ref].all.isActive ? allRef.classList.add('categGraphSelected') : allRef.classList.remove('categGraphSelected');
            }
          }
        }
      },
      checkMoveWorst(e) {
        return e.to.childElementCount >= 3 ? false : null; 
      },
      createObjectURL(file) {
        return URL.createObjectURL(file);
      },
      applyTableRowColor(question) {
        if (question.skipped) {
          return '#ECECEC';
        } else if (question.highest_possible_score <= question.selected_score) {
          return '#ace2c6';
        } else if (question.selected_score == 0) {
          return '#FEF0D6';
        } else if (question.selected_score > 0 && question.selected_score < question.highest_possible_score) {
          return '#d9f2e6';
        } else {
          return '#eab8b8';
        }
      },
      physicalMappingButton() {
        alert('Please refer to win3hub for this portion');
      },
      compareSettingsButton() {
        alert('N/A')
      },
      compareSimiliarButton() {
        alert('N/A')
      },
      toggleAccordion(event) {
        let ref = event.target;
        ref.classList.toggle('accordion-active');
        let panel = ref.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      },
      lowerSliderChange(event, object) {
        let lower = Number(event.target.value);
        let upper = Number(event.target.nextSibling.value);
        let track = event.target.parentNode.lastChild;
        if (lower >= upper) {
          event.target.value = upper;
        }
        object.outlierValues = [lower, upper];
        track.style.background = `linear-gradient(to right, #000000 ${((lower/100)*100).toFixed(2)}%, #466496 ${((lower/100)*100).toFixed(2)}%, #466496 ${((upper/100)*100).toFixed(2)}%, #000000 ${((upper/100)*100).toFixed(2)}%)`;
      },
      upperSliderChange(event, object) {
        let lower = Number(event.target.previousSibling.value);
        let upper = Number(event.target.value);
        let track = event.target.parentNode.lastChild;
        if (lower >= upper) {
          event.target.value = lower;
        }
        object.outlierValues = [lower, upper];
        track.style.background = `linear-gradient(to right, #000000 ${((lower/100)*100).toFixed(2)}%, #466496 ${((lower/100)*100).toFixed(2)}%, #466496 ${((upper/100)*100).toFixed(2)}%, #000000 ${((upper/100)*100).toFixed(2)}%)`;
      },
    }
  };
</script>

<style lang="scss" scoped>
  @use '../sharedSCSS/globalSharedVariables';

  $sidebar-width: 300px;

  #configureReportNewApp-container {

    textarea {
      padding: 5px;
      width: 100%;
    }

    .info-box {
      padding: 1rem;
      background-color: globalSharedVariables.$background-white-1;
      border: 1px globalSharedVariables.$grey-200 solid;
      border-radius: 1rem;
      margin: 1rem 0;
    }

    .accordion-container {
      .accordion-content {
        textarea {
          color: #0A0A0A80;
        }
      }
    }

    #main-box {
      margin-left: $sidebar-width;
      padding: 1rem;
      background-color: globalSharedVariables.$background-grey-1;

      #Initial-Info-container {
        position: relative;

        #button-navigation-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: fixed;
          right: 1px;
          top: 50%;
          transform: translateY(-50%);
          background-color: globalSharedVariables.$brand-100;
          padding: 1px;
          z-index: 5;

          > span {
            font-weight: 700;
            font-size: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: globalSharedVariables.$brand-100;
            width: 35px;
            height: 35px;
            border: 1px #EBEBEB solid;

            a {
              color: inherit;

              &:hover {
                color: globalSharedVariables.$brand-600;
              }
            }
          }
        }

        #initInfo-background-info {
          display: flex;

          > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
          }

          #initInfo-grid {
            display: grid;
            grid-template-columns: auto auto;
            column-gap: 2rem;
            flex: 3;

            div:nth-child(4n-3),
            div:nth-child(4n-2) {
              font-weight: 700;
              color: globalSharedVariables.$brand-600;
            }

/*             div:nth-child(4n),
            div:nth-child(4n-1) {
              
            } */
          }
        }

        #subjective-scoring-container {
          > div {
            width: 100%;
            padding: 1rem;
            margin: 1rem 0;
          }
        }

        .custom-slider-container {
          $thumb-width: 30px;
          position: relative;
          padding: 1rem 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;

          input[type="range"] {
            -webkit-appearance: none;
            appearance: none;
            width: 100%;
            cursor: pointer;
            outline: none;
            border-radius: 15px;
            height: 4px;
            
            &::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              height: $thumb-width;
              width: $thumb-width;
              background-color: globalSharedVariables.$brand-300;
              border-radius: 50%;
              border: none;
              transition: .2s ease-in-out;
              position: relative;
              z-index: 20;
            }
          }

          .track {
            height: 2px;
            background: linear-gradient(to right, #FF4444 44.5%, #FAFF00 44.5%, #FAFF00 77.75%, #00FF29 77.75%);
            position: absolute;
            width: calc(100% - 30px);
            top: 50%;
            transform: translateY(-50%);
            padding: 0 15px;
          }

          .sliderticks {
            display: flex;
            justify-content: space-between;
            position: absolute;
            width: 100%;
            top: 50%;
            transform: translateY(-50%);
            padding: 0 15px;
          }

          .sliderticks span {
            display: flex;
            justify-content: center;
            width: 2px;
            height: 30px;
            background: #0FA958;
            line-height: 90px;
            position: relative;
            z-index: 30;
          }
        }

        #top-categ-skipped-container {
          display: inline-flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          margin: 1rem;
          text-align: center;
          width: 300px;

          > div {
            width: 75%;
            background-color: lightgrey;
            border-radius: 10px;
            padding: 5px;
          }
        }

        #strong-weak-categ-container {
          display: inline-flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          margin: 1rem;
          text-align: center;
          width: 300px;

          > div {
            width: 75%;
            border-radius: 10px;
            padding: 5px;
          }

          > div:nth-child(1) {
            background-color: #DCFCE7;
            border: solid 1px #7BF1A7;
            color: #0D542B;
          }

          > div:nth-child(2) {
            background-color: #FFEDD4;
            border: solid 1px #FFB86A;
            color: #7E2A0C;
          }
        }
      }

      #Test-Scores-container {
        #strongest-weakest-category-container {
          display: flex;
          justify-content: flex-end;
          margin: 5px;

          .grid-container {
            display: grid;
            grid-template-columns: 200px 200px;
            column-gap: 10px;
            font-weight: 400;
            text-align: center;

            > div:nth-child(1) {
              background-color: #DCFCE7;
              border: solid 1px #7BF1A7;
              color: #0D542B;
              border-radius: 10px;
            }

            > div:nth-child(2) {
              background-color: #FFEDD4;
              border: solid 1px #FFB86A;
              color: #7E2A0C;
              border-radius: 10px;
            }
          }
        }

        #change-default-category-button-row-container {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .half-pill {
            display: inline-block;
            height: 30px;
            padding-left: 10px;
            padding-right: 10px;
            cursor: default;
          }

          .left-half {
            border-radius: 15px 0 0 15px;
            border: 1px solid #CCCCCC;
            cursor: pointer;

            &:hover {
              background-color: globalSharedVariables.$brand-100;
            }
          }

          .right-half {
            border-radius: 0 15px 15px 0;
            border: 1px solid #CCCCCC;
            cursor: pointer;

            &:hover {
              background-color: globalSharedVariables.$brand-100;
            }
          }

          .selectedPillHalf {
            border: 1px solid globalSharedVariables.$brand-300;
            background-color: globalSharedVariables.$brand-100;
          }
        }

        #default-view-test-scores-container {
          h4 {
            margin-top: 1rem;
          }

          table {
            max-height: 400px;
            overflow: auto;

            .media-icons-container {
              > span {
                position: relative;
                display: inline-block;
              }

              > span > * {
                margin: 0 2px;
              }

              .red-dot {
                height: 3px;
                width: 3px;
                background-color: red;
                border-radius: 50%;
                display: inline-block;
                position: absolute;
                top: 0;
                right: 0;
              }
            }
          }
        }

        #categ-view-test-scores-container {
          .gridParent-categ {
            display: grid;
            grid-template-columns: 70% 30%;

            > div:nth-child(1) {
              padding: 0 1rem;

              .categ-navigation-container {
                display: flex;
                justify-content: center;
                align-items: center;
                user-select: none;
                font-size: 2rem;

                h3 {
                  margin: 0;
                }
              }

              table {
                overflow: auto;
              }
            }

            > div:nth-child(2) {
              textarea {
                height: 50vh;
              }
            }
          } 
        }
      }

      #Attention-Emotion-container {
        > div {
          margin-top: 2rem;

          > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }

      #Graphs-Plots-container {
        h4 {
          margin-top: 1rem;
        }

        .radioGrid-container {
          display: grid;
          grid-template-columns: 150px 150px 150px 150px 150px 150px;
          margin-bottom: 2rem;

          .categGraphOptions {
            display: inline-block;
            width: 15px;
            height: 15px;
            background-color: #ccc;
            cursor: pointer;
          }

          .categGraphSelected {
            background-color: globalSharedVariables.$brand-300;
          }

          .categGraphOptedOut {
          }
        }

        .custom-slider-container {
          $thumb-width: 30px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;

          input[type="range"] {
            -webkit-appearance: none;
            appearance: none;
            position: absolute;
            width: 100%;
            cursor: pointer;
            outline: none;
            border-radius: 15px;
            height: 4px;
            
            &::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              height: $thumb-width;
              width: $thumb-width;
              background-color: globalSharedVariables.$brand-300;
              border-radius: 50%;
              border: none;
              transition: .2s ease-in-out;
              position: relative;
              z-index: 20;
              cursor: grab;
            }
          }

          .track {
            height: 5px;
            border-radius: 50rem;
            background-color: #466496;
            position: absolute;
            width: calc(100% - 30px);
            top: 50%;
            transform: translateY(-50%);
            padding: 0 15px;
          }
        }

        .plotDrop-container {
          margin-top: 5px;

          > .plotDrop-content-container {
            > div:nth-child(1) {
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              width: 100%;
              height: 100%;

              .plotDrop-sideBar {
                background-color: rgb(240, 240, 240);
                position: absolute;
                left: 0;
                top: 0;
                width: 0;
                font-size: .7em;
                overflow: auto;
              }

              .plotDrop-sideBar-open {
                width: 100%;
                height: 100%;
                max-height: 900px;
                padding: 1rem;
              }

              .plotDrop-draggable-used, .plotDrop-draggable-removed {
                flex: 1;
                border: 2px solid globalSharedVariables.$brand-300;
                border-radius: 5px;
                margin: 5px;
                padding: 10px;
                display: flex;
                flex-direction: column;
              }

              .plotDrop-drag-category {
                cursor: grab;
                background-color: globalSharedVariables.$brand-100;
                border: solid 1px black;
                border-radius: 50rem;
                text-align: center;
                margin-bottom: 2px;
              }
            }

            > div:nth-child(2) {
              .plotDrop-customizeB {
                text-align: center;
                width: 90%;
                border: 2px solid #b1b4b8;
                border-radius: 50rem;
                cursor: pointer;
                box-shadow: 0 0 5px 0 grey;

                &:hover {
                  background-color: #D7DCE1;
                }
              }
            }
          }
        }
      }

      #Summary-Recomm-container {
        h2 {
          margin-bottom: 2rem;
        }

        .title-opt-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      #Root-Cause-Analysis-container {
        .nav-button-group {
          display: flex;
          justify-content: flex-end;

          button {
            margin: 0 2px;
          }
        }
      }

      #Config-Order-container {
        .drag-item {
          cursor: grab;
          font-size: medium;
          display: grid;
          grid-template-columns: 15px auto 100px;
        }

        .drag-item-deactivated {
          cursor: grab;
          display: grid;
          grid-template-columns: 25px auto 25px;
          opacity: .5;
          position: relative;
        }

        .drag-item-deactivated::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          border-top: 1px solid black;

          > div {
            display: flex;
            align-items: center;
          }
        }
      }
    }

    #sideBar-box {
      width: $sidebar-width;
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: auto;
      background-color: globalSharedVariables.$background-white-1;
      border-left: solid globalSharedVariables.$grey-200 1px;
      border-right: solid globalSharedVariables.$grey-200 1px;
      height: calc(100dvh - #{globalSharedVariables.$navbar-height});
      padding: 1rem;

      > div:nth-child(1) {
        ul, li {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        li {
          cursor: pointer;
          user-select: none;
          padding: .5rem;
          margin: .5rem 0;
          border-radius: 5px;
          font-weight: 700;

          &:hover {
            background-color: globalSharedVariables.$brand-50;
          }

          &.navClick {
            color: globalSharedVariables.$brand-700;
            background-color: globalSharedVariables.$brand-50;
            position: relative;

            svg {
              stroke: globalSharedVariables.$brand-700;
            }
          }

          svg {
            width: 20px;
            height: 20px;
            stroke: #1F1F1F;
          }

        }

        button {
          width: 100%;
        }
      }

      > div:nth-child(2) {
        button {
          width: 100%;
          margin: 5px 0;
        }
      }
    }
  }

  #Preview-container {
    #example-pdf-html-container {
      width: 794px;
      padding: 95px;
      background: white;
      box-shadow: 0 0 5px rgba(0,0,0,0.2);
      margin: auto;

      #title-report-container {
        display: grid;
        grid-template-columns: auto 1fr;

        svg {
          width: 150px;
          height: auto;
        }

        h2 {
          text-align: center;
        }
      }

      .tester {
        min-height: 100px;
        position: relative;
        color: black;
        background-color: #fdfdfd;
        padding: 1rem;
        margin: 1rem 0;
        border-radius: 10px;
        border: solid 1px grey;
        font-weight: 700;

        > div {
          font-weight: 400;
        }
      }

      hr {
        border: none;
        height: 2px;
        background-color: black;
      }
    }
  }

  /* TextBox */
  #obserComments, #atteSocEmoFunc, #riskSum, #summConclus,
  #furthTask, #techDetail {
    background-color: white;
    border-radius: 8px;
    border: 1px globalSharedVariables.$brand-300 solid;
  }

</style>